export default "__VITE_ASSET__CbkvbWlD__"